import { render, staticRenderFns } from "./StatusBadge.vue?vue&type=template&id=548e6c4b&scoped=true"
import script from "./StatusBadge.vue?vue&type=script&lang=ts"
export * from "./StatusBadge.vue?vue&type=script&lang=ts"
import style0 from "./StatusBadge.vue?vue&type=style&index=0&id=548e6c4b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548e6c4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('548e6c4b')) {
      api.createRecord('548e6c4b', component.options)
    } else {
      api.reload('548e6c4b', component.options)
    }
    module.hot.accept("./StatusBadge.vue?vue&type=template&id=548e6c4b&scoped=true", function () {
      api.rerender('548e6c4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/StatusBadge.vue"
export default component.exports